// extracted by mini-css-extract-plugin
export default {"card":"t3s26QVSgcFUkHVBkvzg","blue":"YBqXTHtZdoI2dlR0_OAO","noBorder":"REyVfb2erf58AT5wCL_r","padded":"eAbotUBPWgjCTqTr4SJ9","pulse":"jPMouSgqiDAvprkEvFWH"};